import type { AdTemplate } from '@adflow/types';

/** Starter animation presets are authored for Figma (HTML) templates only. */
export function supportsTemplateAnimations(
  importSourceType: AdTemplate['importSourceType'] | undefined,
): boolean {
  return importSourceType === 'figma';
}
